import React, { useEffect, useState } from "react";
import Loader from "../../Components/Loader/Loader";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ManageVouchersApi } from "../../Utils/Api/ManageVouchers";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/ErrorMessages";
import {
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { userId } from "../../Utils/LocalStorage";
import defaultupload from "../../assets/default-upload.svg";
import defaultupload_fb from "../../assets/default-fb.png";
import iicon from "../../assets/i.svg";
import DatePicker from "react-datepicker";
import Datepickericon from "../../assets/date-picker.svg";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { formatDate } from "../../Utils/FormatDate";

export const ViewVoucher = () => {
  const navigate = useNavigate();
  const uid = userId();
  const { voucherId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDate, setAvailableDate] = useState(null);

  useEffect(() => {
    getVoucherDetails();
  }, []);

  const getVoucherDetails = async () => {
    setLoading(true);
    const payload = {
      business_id: parseInt(uid),
      voucher_id: parseInt(voucherId),
      limit: 8,
      offset: 0,
    };
    const Response = await ManageVouchersApi(payload, () => {
      navigate("/");
    });
    if (Response === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (Response.status === 429) {
        toast.error(Response.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(true);
      } else if (Response.success === true) {
        setData(Response.data[0]);
        setStartDate(formatDate(Response.data[0]?.start_date));
        setAvailableDate(
          formatDate(Response.data[0]?.voucher_avail_until_date)
        );
        setEndDate(formatDate(Response.data[0]?.end_date));
        setLoading(false);
      }
    }
  };

  return (
    <div>
      {loading ? <Loader /> : ""}{" "}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-account/manage-vouchers"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">View Voucher</p>
          <div className="acc-dashboard mt-4">
            <div className="input_fileds">
              <Form className="formmain mx-2 mt-2 signin-row profile-form pb-4 Create-Vouch">
                <Row>
                  <Col md="12">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Voucher Name <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          style={{ width: "100%" }}
                          type="text"
                          value={data.voucher_name}
                          placeholder="Voucher Name"
                          className="custom-formcontrol"
                          maxLength={200}
                          name="voucher_name"
                          autoComplete="off"
                          disabled={true}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
                {/* images */}
                <div className="d-flex gap-30 marginTop-40 mb-4 img_sec_product">
                  {/* logo */}
                  <div className="col-4 px-0 mb-2">
                    <div className="image-upload-crop">
                      <p className="uploadtextmain">
                        Voucher Image &nbsp;
                        <span className="star-required">*</span>
                        <br />
                        <span className="info_text">
                          (Recommended size 1000 x 1000)
                        </span>
                      </p>
                      <div
                        className="upload_banner_empty_logo"
                        style={{ cursor: "not-allowed" }}
                      >
                        <img
                          loading="lazy"
                          className={
                            data.voucher_image == ""
                              ? "default-img"
                              : "product-img"
                          }
                          src={
                            data.voucher_image == ""
                              ? defaultupload
                              : data.voucher_image
                          }
                          height="300"
                          width="300"
                          alt="voucher-img"
                        />
                      </div>
                    </div>
                  </div>
                  {/* fb */}
                  <div className="col-8 px-0">
                    <p className="uploadtextmain">
                      Social Share Image &nbsp;
                      <br />
                      <span className="info_text">
                        (Recommended size 1200px x 630px)
                      </span>
                    </p>
                    <div
                      className="upload_banner_empty_fb"
                      style={{ cursor: "not-allowed" }}
                    >
                      <img
                        className={
                          data.voucher_social_image == ""
                            ? "default-img"
                            : "product-img"
                        }
                        loading="lazy"
                        src={
                          data.voucher_social_image == ""
                            ? defaultupload_fb
                            : data.voucher_social_image
                        }
                        alt="voucher-social-img"
                      />
                    </div>
                  </div>
                </div>
                {/* limit,.. */}
                <Row className="VoucherAmountDollar marginTop-40 mb-4">
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <div>
                          <p className="VoucherP VLimit">Voucher</p>
                          <p>
                            Limit
                            <span className="star-required">
                              *
                              {["top"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${placement}`}
                                      style={{ width: "50%" }}
                                    >
                                      This field indicates quantity of the
                                      voucher.
                                    </Tooltip>
                                  }
                                >
                                  <Image
                                    loading="lazy"
                                    src={iicon}
                                    className="mb-1"
                                    width="15px"
                                  ></Image>
                                </OverlayTrigger>
                              ))}
                            </span>
                          </p>
                        </div>
                      </Form.Label>

                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={data.total}
                            placeholder="Voucher Limit"
                            className="custom-formcontrol"
                            maxLength={3}
                            name="voucher_limit"
                            autoComplete="off"
                            disabled={true}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <div>
                          <p className="VoucherP VValue">Voucher Retail</p>
                          <p>
                            Value($)
                            <span className="star-required">
                              *
                              {["top"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${placement}`}
                                      style={{ width: "50%" }}
                                    >
                                      This is the actual price of the voucher.
                                    </Tooltip>
                                  }
                                >
                                  <Image
                                    loading="lazy"
                                    src={iicon}
                                    className="mb-1"
                                    width="15px"
                                  ></Image>
                                </OverlayTrigger>
                              ))}
                            </span>
                          </p>
                        </div>
                      </Form.Label>

                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            placeholder="Voucher Retail Value"
                            className="custom-formcontrol"
                            value={data.voucher_value}
                            maxLength={10}
                            name="voucher_value"
                            autoComplete="off"
                            disabled={true}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <div>
                          <p className="VoucherP VDiscount">
                            Voucher Discounted{" "}
                          </p>
                          <p>
                            Price($)
                            <span className="star-required">
                              *{" "}
                              {["top"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${placement}`}
                                      style={{ width: "fit-content" }}
                                    >
                                      This is the discounted price of the
                                      voucher.
                                    </Tooltip>
                                  }
                                >
                                  <Image
                                    loading="lazy"
                                    src={iicon}
                                    className="mb-1"
                                    width="15px"
                                  ></Image>
                                </OverlayTrigger>
                              ))}
                            </span>
                          </p>
                        </div>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            placeholder="Voucher Discounted Price"
                            className="custom-formcontrol"
                            maxLength={10}
                            name="voucher_price"
                            value={data.voucher_price}
                            autoComplete="off"
                            disabled={true}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                {/* date,.. */}
                <Row className="VoucherAmountDollar marginTop-40 mb-4">
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VLimit">
                          Voucher Publish Start Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={startDate}
                            placeholder="Coupon code"
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                          {/* <DatePicker
                            selected={startDate}
                            className="custom-formcontrol"
                            placeholderText="Publish Start Date"
                          /> */}
                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VValue">
                          Voucher Available Until Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={availableDate}
                            placeholder="Coupon code"
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                          {/* <DatePicker
                            selected={availableDate}
                            className="custom-formcontrol"
                            placeholderText="Available Until Date"
                          /> */}
                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        <p className="VoucherP VDiscount">
                          Voucher Expiration Date
                          <span className="star-required">*</span>
                        </p>
                      </Form.Label>
                      <div className="editInputDiv">
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={endDate}
                            placeholder="Coupon code"
                            className="custom-formcontrol"
                            autoComplete="off"
                            disabled={true}
                          />
                          {/* <DatePicker
                            selected={endDate}
                            className="custom-formcontrol"
                            placeholderText="Expiration Date"
                          /> */}
                          <Image
                            loading="lazy"
                            src={Datepickericon}
                            className="date-picker-icon"
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                {/* description */}
                <Row className="mx-2 desc_terms_condition create_Voucher_Desc_Row mb-4 marginTop-40">
                  <Col md="12" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom info-sec">
                        Voucher Description{" "}
                        <span className="star-required">*</span>{" "}
                      </Form.Label>
                      <FroalaEditorView model={data?.voucher_description} />
                    </Form.Group>
                  </Col>
                </Row>
                {/* t&c */}
                <Row className="mx-2 desc_terms_condition marginTop-40">
                  <Col md="12" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Terms & Conditions
                        <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Group
                        className="mb-3 ack fr-view"
                        controlId="formBasicCheckbox"
                      >
                        {data.voucher_tnc
                          ? data?.voucher_tnc.map((item) => {
                              return (
                                <ul>
                                  <li>{item}</li>
                                </ul>
                              );
                            })
                          : " "}
                      </Form.Group>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </div>
  );
};
